// extracted by mini-css-extract-plugin
export default {"settingsMenu":"settingsMenu--U_KME","settingsMenuItem":"settingsMenuItem--O3zdU","wizardQuestionaryHeaderButton":"wizardQuestionaryHeaderButton--Gq1Bl","textWrap":"textWrap--FbQcI"};